export default "__VITE_ASSET__DZBw4o89__"